"use client";

import { useMemo } from "react";

import { Nullable } from "@/types/common";
import { TransformationType } from "@/types/thread";
import { useAppSelector } from "@/redux/store";
import { useGenContext } from "@/context/GenContext";
import ImageGenCarousel from "./ImageGenCarousel";

const getDisplayStatus = (
  status: Nullable<string>,
  jobType: Nullable<TransformationType>
) => {
  if (
    status === "submitted" ||
    status === "preparing" ||
    status === "prepared"
  ) {
    return "Your generation has been added to the queue...";
  }
  if (status === "in_progress") {
    if (jobType === TransformationType.Enhance)
      return "Enhancing your image...";
    return "Generating images based on your description...";
  }
  return "Loading...";
};

const GenerationStatus: React.FC<{
  status: Nullable<string>;
}> = ({ status }) => {
  const jobType = useAppSelector((state) => state.room.jobType);

  const { state: genState } = useGenContext();

  const currentPrompt = genState.prompt || "creative digital artwork";

  const displayStatus = useMemo(() => {
    return getDisplayStatus(status, jobType);
  }, [status, jobType]);

  return <ImageGenCarousel statusText={displayStatus} prompt={currentPrompt} />;
};

export default GenerationStatus;
